import { useHeaderState } from "@faire/retailer-visitor-shared/components/Header/useHeaderState";
import { useSearchPageSpellCorrectedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { PathParameters as DiscoverSearchPathParameters } from "@faire/web-api--source/routes/www/discover/searchTerm";
import { QueryParameters as SearchQueryParameters } from "@faire/web-api--source/routes/www/search";
import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

// To be removed after we complete Phase 3
export const useSearchPageViewStateLifeCycle = () => {
  const location = useLocation();
  const signInQueryParam =
    parseQueryParams(location.search).get("signIn") ?? undefined;
  const queryParams = useQueryParams(SearchQueryParameters.parse);
  const { searchTerm } = useParams<DiscoverSearchPathParameters>();
  const previousQueryParams = useRef<SearchQueryParameters>(queryParams);
  const productSearchString = useSearchPageProductSearchString();
  const previousProductSearchString = useRef(productSearchString);
  const spellCorrectedQuery = useSearchPageSpellCorrectedQuery();
  const { setSearchQuery } = useHeaderState();

  React.useEffect(() => {
    const headerSearchQuery = spellCorrectedQuery ?? productSearchString;
    setSearchQuery(headerSearchQuery);

    if (
      previousQueryParams.current !== queryParams ||
      previousProductSearchString.current !== productSearchString
    ) {
      const stopScrollingToTop =
        !!previousQueryParams.current?.signUp ||
        !!queryParams.signUp ||
        previousProductSearchString.current === productSearchString;
      if (!stopScrollingToTop) {
        getWindowOrThrow().scrollTo?.(0, 0);
      }

      previousQueryParams.current = queryParams;
      previousProductSearchString.current = productSearchString;
    }
  }, [
    location,
    productSearchString,
    queryParams,
    searchTerm,
    setSearchQuery,
    signInQueryParam,
    spellCorrectedQuery,
  ]);
};
